"use strict";

function e(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}
Object.defineProperty(exports, "__esModule", {
  value: !0
});
var n,
  t,
  r,
  i,
  a,
  o,
  l,
  s,
  p,
  d = require("styled-components"),
  u = e(d),
  c = require("./_commonjsHelpers-7f6ebd13.js"),
  g = require("react"),
  m = e(g),
  f = require("./index-35aaa6c4.js"),
  h = require("lodash"),
  x = require("./styled.helpers-645c7a46.js"),
  b = u.div(n || (n = c._taggedTemplateLiteral(["\n  > * + * {\n    margin-left:  0.5rem;\n  }\n\n  ", "\n"])), [["small", ".25rem"], ["medium", "1.2rem"], ["large", "1.5rem"]].map(function (e) {
    var n = c._slicedToArray(e, 2),
      r = n[0],
      i = n[1];
    return x.withProp(r)(d.css(t || (t = c._taggedTemplateLiteral(["\n    > * + * {\n      margin-left: ", ";\n    }\n  "])), i));
  })),
  v = u.div(r || (r = c._taggedTemplateLiteral(["\n\tpadding: 0.1px 0;\n\t\n\t/** DO NO MOVE 'noExtraSpace' FROM HERE **/\n\t", "\n\n\t> * + * {\n\t\tmargin-top: 1rem;\n\t}\n\t\n\t", "\n\t\n\t", "\n"])), x.withProp("noExtraSpace", d.css(i || (i = c._taggedTemplateLiteral(["\n      > * {\n        margin-top: 0;\n        margin-bottom: 0;\n      }\n    "])))), x.withProp("noEmpty", d.css(a || (a = c._taggedTemplateLiteral(["\n      > * + * {\n        margin-top: unset;\n      }\n      > * + *:not(:empty) {\n        margin-top: 1rem;\n      }\n    "])))), [["small", ".5rem"], ["medium", "1.5rem"], ["large", "2rem"]].map(function (e) {
    var n = c._slicedToArray(e, 2),
      t = n[0],
      r = n[1];
    return x.withProp(t, d.css(o || (o = c._taggedTemplateLiteral(["\n        > * + * {\n          margin-top: ", ";\n        }\n\n        ", "\n      "])), r, x.withProp("noEmpty", d.css(l || (l = c._taggedTemplateLiteral(["\n            > * + * {\n              margin-top: unset;\n            }\n            > * + *:not(:empty) {\n              margin-top: ", ";\n            }\n          "])), r))));
  })),
  y = function (e) {
    return m.createElement(v, e);
  };
y.Flex = u(y)(s || (s = c._taggedTemplateLiteral(["\n  display: flex;\n  flex-grow: 1;\n  width: 100%;\n  flex-direction: column;\n  ", "\n"])), x.propsOr({
  "align-items": "flex-start",
  "justify-content": "flex-start",
  "align-content": "flex-end"
}));
var w = u.div(p || (p = c._taggedTemplateLiteral(["\n  box-sizing: border-box;\n  max-width: 100%;\n\n  .wg--hr_bounce {\n    transition-timing-function: cubic-bezier(0.78, 0.05, 0.41, 0.92);\n  }\n\n  #page-holder {\n    height: 100%;\n    width: 100%;\n    overflow: hidden;\n    box-sizing: border-box;\n    display: flex;\n    flex-wrap: nowrap;\n    boxsizing: border-box;\n    scroll-snap-type: x mandatory;\n    transition: height 0.3s ease-out;\n    transition-property: all;\n    transition-duration: 0.3s;\n\n    &.is-absolute {\n      width: 100%;\n      position: absolute;\n    }\n\n    .page {\n      height: 100%;\n      flex-shrink: 0;\n      margin-left: 0px;\n      scroll-snap-align: start;\n      display: inline-block;\n      box-sizing: border-box;\n\n      &:first-child {\n        margin-left: 0;\n      }\n    }\n  }\n"]))),
  T = m.createContext(),
  _ = T.Consumer,
  k = function () {
    return m.useContext(T);
  },
  E = function (e) {
    var n = e.children,
      t = m.useState(0),
      r = c._slicedToArray(t, 2),
      i = r[0],
      a = r[1];
    return m.createElement(T.Provider, {
      value: {
        currentPage: i,
        next: function () {
          return a(i + 1);
        },
        prev: function () {
          return i >= 1 && a(i - 1);
        },
        goto: function (e) {
          return e >= 0 && a(e);
        }
      }
    }, n);
  };
E.propTypes = {
  children: f.t.node.isRequired
};
var L = function (e) {
  var n = e.current,
    t = k(),
    r = t.currentPage,
    i = t.goto,
    a = g.useState("auto"),
    o = c._slicedToArray(a, 2),
    l = o[0],
    s = o[1];
  m.useEffect(function () {
    i(n);
  }, []);
  var p = g.useCallback(function (e, n) {
      return n.current.clientWidth * e;
    }, []),
    d = g.useRef(null),
    u = g.useRef(null),
    f = [],
    x = g.useCallback(function (e, n) {
      f[n] = e;
    }, [f]);
  return g.useEffect(function () {
    if (u.current) {
      var n = p(r, u);
      u.current.scroll({
        top: 0,
        left: n,
        behavior: "smooth"
      });
    }
    if (e.morph) {
      h.debounce(function () {
        if (f[r]) {
          var e = f[r].clientHeight + "px";
          l !== e && s(e);
        }
      }, 500)();
    } else s("auto");
  }, [r, f, l, e, p]), m.createElement(w, {
    ref: d
  }, m.createElement("section", {
    id: "page-holder",
    ref: u,
    style: {
      height: l
    }
  }, m.Children.map(e.children, function (e, n) {
    return m.createElement(j, {
      key: n,
      ref: function (e) {
        return x(e, n);
      },
      width: u.current ? u.width + "px" : "100%",
      isActive: r == n
    }, e);
  })));
};
L.propTypes = {
  morph: f.t.bool,
  current: f.t.number.isRequired,
  children: f.t.array.isRequired
}, L.defaultProps = {
  current: 0,
  morph: !1
};
var P,
  q,
  R,
  z,
  C,
  j = m.forwardRef(function (e, n) {
    var t = e.width,
      r = e.isActive,
      i = e.children;
    return m.createElement("section", {
      className: "page ".concat(r ? "pager--active" : ""),
      style: {
        width: t
      }
    }, m.createElement("div", {
      ref: n,
      className: "wg-slider-page px-15"
    }, i));
  });
j.propTypes = {
  children: f.t.node,
  isActive: f.t.bool.isRequired,
  width: f.t.string.isRequired
};
var A,
  O,
  S = function (e) {
    return e.propTypes = {
      horizontal: f.t.bool,
      vertical: f.t.bool,
      x: f.t.bool,
      y: f.t.bool,
      children: f.t.node.isRequired
    }, e;
  },
  N = function (e) {
    return function (n) {
      return function (t) {
        return e.map(function (e) {
          return x.withProp(e)(n)(t);
        });
      };
    };
  },
  H = u.span(P || (P = c._taggedTemplateLiteral(["\n\tdisplay: inline-block;\n\tbox-sizing: border-box;\n\twidth: 100%;\n\tpadding: 5rem;\n\n\t", "\n\n\t", "\n"])), N(["vertical", "y"])(d.css(q || (q = c._taggedTemplateLiteral(["\n\t\tpadding-left: 0 !important;\n\t\tpadding-right: 0 !important;\n\t"])))), N(["horizontal", "x"])(d.css(R || (R = c._taggedTemplateLiteral(["\n\t\tpadding-top: 0 !important;\n\t\tpadding-bottom: 0 !important;\n\t"]))))),
  M = u(H)(z || (z = c._taggedTemplateLiteral(["\n\tpadding: 1rem;\n"]))),
  F = S(u(H)(C || (C = c._taggedTemplateLiteral(["\n\tpadding: 2.5rem;\n"])))),
  W = S(M),
  D = S(H);
F.Large = D, F.Small = W;
var I,
  V,
  B = function (e) {
    return e.color || "orange";
  },
  G = u.div(A || (A = c._taggedTemplateLiteral(["\n    & > * {\n        outline: solid 1px ", ";\n    }\n\n    ", "\n"])), B, x.withProp("all")(d.css(O || (O = c._taggedTemplateLiteral(["\n        * {\n            outline: solid 1px ", ";\n        }\n    "])), B))),
  J = u.img(I || (I = c._taggedTemplateLiteral(["\n\twidth: 100%;\n\theight: 25vh;\n\tmin-height: 250px;\n\tobject-fit: cover;\n\tborder-radius: 12px;\n"]))),
  K = function (e) {
    return function (n) {
      return n.theme.skeleton[e];
    };
  },
  Q = u.div(V || (V = c._taggedTemplateLiteral(["\n  background-size: 200px;\n  animation: skeleton 2s running infinite forwards linear;\n  background: linear-gradient(90deg, ", ", ", ", ", ");\n\n  @keyframes skeleton {\n    0% {\n      background-position-x: 0px;\n    }\n\n    25% {\n      background-position-x: 50px;\n    }\n\n    50% {\n      background-position-x: 250px;\n    }\n    75% { background-position-x: 250px }\n    100% { background-position-x: 250px }\n  }\n"])), K("from"), K("to"), K("from")),
  U = function (e) {
    var n = e.width,
      t = e.height;
    return m.createElement(Q, c._extends({}, e, {
      style: {
        width: n,
        height: t
      }
    }));
  };
U.propTypes = {
  width: f.t.number.isRequired,
  height: f.t.number.isRequired
}, exports.Cluster = F, exports.CoverImage = function () {
  return m.createElement(J, {
    className: "w-4/5",
    src: "/images/vendor_banner.png"
  });
}, exports.Outline = G, exports.Pager = L, exports.PagerConsumer = _, exports.PagerProvider = E, exports.SkeletonWrapper = U, exports.Stack = y, exports.Tab = function (e) {
  return m.createElement(b, e);
}, exports.usePager = k;